export type some = { [key: string]: any };
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const BASE_URL = "https://dev-api.tripi.vn";
export const APP_KEY = "kasdhasdhakdjkad";
export const APP_ID = "hms-web";
export const VERSION = "1.0";

export const SUCCESS_CODE = 200;
export const environment = {
  production: false,
  SERVER_API_URL: "http://chat.dev.tripi.vn",
  LOCAL_API_URL: "http://172.20.181.149:8090",
  BACKEND_SERVER_API_URL: "https://dev-api.tripi.vn",
  TIME_OUT: 30000,
};
export const MAIN_DESKTOP_BACKGROUND_URL =
  "https://storage.googleapis.com/phms-dev/contract/img/1615779045709Vk/group-1837.png";
export const MAIN_MOBILE_BACKGROUND_URL =
  "https://storage.googleapis.com/phms-dev/contract/img/1615779045709Vk/group-1837.png";
export const MAIN_TABLET_BACKGROUND_URL =
  "https://assets.dev.tripi.vn/assets/show/photo/img/1617329620YAVHVL/breakpoint-963.png";
export const PARTNER_LOGO =
  "https://storage.googleapis.com/phms-dev/contract/img/1615780661704VQ/logotripipartner.png";
export const PLANE_INFO_CARD =
  "https://storage.googleapis.com/phms-dev/contract/img/1615780690422Sy/plane.png";
export const EXPLORE_INFO_CARD =
  "https://storage.googleapis.com/phms-dev/contract/img/1615780590950rr/explore.png";
export const CONNECT_INFO_CARD =
  "https://storage.googleapis.com/phms-dev/contract/img/1615780564471Jq/connect.png";
export const NO_PROFILE_IMG =
  "https://storage.googleapis.com/phms-dev/photo/img/1616640684447Rq/group-1838.png";

export const PLANE_INFO_MOBILE_CARD =
  "https://storage.googleapis.com/phms-dev/photo/img/1617703172278Df/rectangle-383.png";
export const EXPLORE_INFO_MOBILE_CARD =
  "https://storage.googleapis.com/phms-dev/photo/img/1617703219353Yq/rectangle-386.png";
export const CONNECT_INFO_MOBILE_CARD =
  "https://storage.googleapis.com/phms-dev/photo/img/1617703248319Et/rectangle-385.png";

export const LOGO_MYTOUR =
  "https://storage.googleapis.com/tripi-assets/mytour/icons/icon_logo_mytour_red.svg";
